import { Step, StepLabel, Stepper } from "@mui/material";
import {
  OrcaDeployState,
  OrcaDeployStateValue,
} from "rest-data-provider/utils/orcaDeployActivityLogsTypes";

const STEPS: Array<{ state: OrcaDeployStateValue; label: string; description: string }> = [
  {
    state: OrcaDeployState.STAGE,
    label: "Stage",
    description: "New version is being built on the second server",
  },
  {
    state: OrcaDeployState.STABLE,
    label: "Stable",
    description: "Prod is stable, no second link shown to users",
  },
  {
    state: OrcaDeployState.UNSTABLE,
    label: "Unstable",
    description: "Prod may be unstable, old version link shown as fallback",
  },
];

export const OrcaDeployLifecycle = (props: { state: OrcaDeployStateValue }) => {
  const activeIndex = STEPS.findIndex((s) => s.state === props.state);

  return (
    <Stepper activeStep={activeIndex} alternativeLabel sx={{ mb: 3 }}>
      {STEPS.map((step) => (
        <Step key={step.state}>
          <StepLabel optional={step.description}>{step.label}</StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};
